import toast from "react-hot-toast";
import { useEffect, useState } from "react";

import {
    useExportUserLogsDataMutation,
    useFetchUserLogsDataMutation,
} from "../../../features/tenant/userLogs/userLogsApi";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import { useGetAppUserTypeQuery } from "../../../features/tenant/appUserType/appUserTypeApi";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";

export default function UserLogsList() {
    const initialRequest = {
        user_type_id: "",
        month: "",
        year: "",
        with_user: true,
        is_active: "",
        limit: 30,
        offset: 0,
    };

    const [request, setRequest] = useState(initialRequest);

    const columns = [
        {
            name: "SNo",
            cell: (row, idx) => request.offset + Number(idx + 1),
            sortable: true,
            width: "80px",
        },
        {
            name: "Name",
            cell: (row) => row.name,
            sortable: true,
            width: "130px",
        },
        {
            name: "Mobile",
            cell: (row) => row.mobile,
            sortable: true,
        },
        {
            name: "User ID",
            cell: (row) => row.user_id,
            sortable: true,
            width: "130px",
        },
        {
            name: "Type",
            cell: (row) => row.user_type,
            sortable: true,
        },
        {
            name: (
                <>
                    No. of
                    <br />
                    Active Day(s)
                </>
            ),
            cell: (row) => (row.active_days || [])?.length,
            sortable: true,
        },
        {
            name: "Month",
            cell: (row) => row.month,
            sortable: true,
        },
        {
            name: "Year",
            cell: (row) => row.year,
            sortable: true,
        },
        {
            name: "Active",
            cell: (row) => (row.is_active ? "Yes" : "No"),
            sortable: true,
        },
        {
            name: "Updated at",
            cell: (row) => new Date(row.updated_at).toLocaleString(),
            sortable: true,
        },
    ];

    const [fetchLogs, { isLoading: logsLoading, data: logsData }] =
        useFetchUserLogsDataMutation();

    const [exportData, { isLoading: exportingLoading, data: exportingData }] =
        useExportUserLogsDataMutation();

    const { data: userTypesData } = useGetAppUserTypeQuery({
        token: sessionStorage.getItem("access_token"),
        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
    });

    const intialize = async (query = {}) => {
        await fetchLogs({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData"))
                .tenant_id,
            query: query,
        });
    };

    const handlePageChange = (pageNumber) => {
        const newOffset = (pageNumber - 1) * request.limit;
        let updatedRequest = {
            ...request,
            offset: newOffset,
        };

        setRequest(updatedRequest);
        intialize(updatedRequest);
    };

    const handlePerRowsChange = (newPerPage, page) => {
        let updatedRequest = {
            ...request,
            limit: newPerPage,
            offset: 0,
        };

        setRequest(updatedRequest);
        intialize(updatedRequest);
    };

    const clearFilters = () => {
        setRequest(initialRequest);
        intialize(initialRequest);
    };

    const callExportData = async () => {
        const response = await exportData({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData"))
                .tenant_id,
            body: request,
        }).unwrap();

        const fileLink = response?.body?.fileLink;

        if (fileLink) {
            const anchor = document.createElement("a");
            anchor.href = fileLink;
            anchor.download = response?.body?.file;
            // anchor.target = "_blank";
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
        } else {
            toast.error("Error exporting CSV");
        }
    };

    useEffect(() => {
        intialize(request);
    }, []);

    return (
        <>
            <div className="flex w-full bg-gray-200 h-full justify-center">
                <div className="w-full ">
                    <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
                        Return List
                        <LinksComponent />
                    </div>

                    <div className="p-3">
                        <div className="flex gap-2 mb-3">
                            <button
                                type="button"
                                onClick={() => callExportData()}
                                className="button border-2 border-gray-400 text-black/70 hover:border-black hover:text-black transition-all px-2 py-1 rounded"
                            >
                                Export Logs (with current filters)
                            </button>
                        </div>

                        <div className=" bg-white shadow rounded-lg">
                            <div className="border-b  border-gray-300 bg-gray-50 rounded-t-lg p-3">
                                <form
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                        intialize(request);
                                    }}
                                    className="flex w-full items-center justify-evenly space-x-2"
                                >
                                    <div className="relative w-full searchin">
                                        <label
                                            className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1"
                                            for="month"
                                        >
                                            Month
                                        </label>
                                        <select
                                            id="month"
                                            name="month"
                                            value={request.month}
                                            className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                            onChange={(e) =>
                                                setRequest((prev) => ({
                                                    ...prev,
                                                    month: e.target.value,
                                                }))
                                            }
                                        >
                                            <option value="">
                                                Select Month
                                            </option>
                                            <option value="1">January</option>
                                            <option value="2">February</option>
                                            <option value="3">March</option>
                                            <option value="4">April</option>
                                            <option value="5">May</option>
                                            <option value="6">June</option>
                                            <option value="7">July</option>
                                            <option value="8">August</option>
                                            <option value="9">September</option>
                                            <option value="10">October</option>
                                            <option value="11">November</option>
                                            <option value="12">December</option>
                                        </select>
                                    </div>

                                    <div className="relative w-full searchin">
                                        <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                            Year
                                        </label>
                                        <input
                                            value={request.year}
                                            onChange={(e) =>
                                                setRequest((prev) => ({
                                                    ...prev,
                                                    year: e.target.value,
                                                }))
                                            }
                                            placeholder="Year"
                                            className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                            type="number"
                                            min={2000}
                                            max={2099}
                                            step={1}
                                        />
                                    </div>

                                    <div className="relative w-full searchin">
                                        <label
                                            className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1"
                                            for="month"
                                        >
                                            User-Type
                                        </label>
                                        <select
                                            id="user-type"
                                            name="user-type"
                                            value={request.user_type_id}
                                            className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                            onChange={(e) =>
                                                setRequest((prev) => ({
                                                    ...prev,
                                                    user_type_id:
                                                        e.target.value,
                                                }))
                                            }
                                        >
                                            <option value="">All</option>
                                            {userTypesData?.body?.map(
                                                (item, index) => (
                                                    <option
                                                        key={index}
                                                        value={
                                                            item?.user_type_id
                                                        }
                                                    >
                                                        {item?.name}
                                                    </option>
                                                )
                                            )}
                                        </select>
                                    </div>

                                    <div className="relative w-full searchin">
                                        <label
                                            className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1"
                                            for="month"
                                        >
                                            Active
                                        </label>
                                        <select
                                            id="active"
                                            name="active"
                                            value={request.is_active}
                                            className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                            onChange={(e) =>
                                                setRequest((prev) => ({
                                                    ...prev,
                                                    is_active: e.target.value,
                                                }))
                                            }
                                        >
                                            <option value="">All</option>
                                            <option value={true}>Active</option>
                                            <option value={false}>
                                                Inactive
                                            </option>
                                        </select>
                                    </div>

                                    <div className="flex flex-row gap-2  w-56 h-10">
                                        <div className="relative searchin">
                                            <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                &nbsp;
                                            </label>
                                            <button
                                                className="btn btn-outline-primary clear-both float-right pdbtn_all "
                                                type="submit"
                                            >
                                                Search
                                            </button>
                                        </div>
                                        <div className="relative searchin">
                                            <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                &nbsp;
                                            </label>
                                            <button
                                                className="btn btn-outline-primary clear-both float-right pdbtn_all whitespace-nowrap"
                                                type="button"
                                                onClick={() => {
                                                    clearFilters();
                                                }}
                                            >
                                                Clear Filters
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>

                            <DataTableComponent
                                keyField={(row, index) =>
                                    request.offset + index
                                }
                                columns={columns}
                                // title={"Product List"}
                                data={logsData?.body?.data}
                                loading={logsLoading}
                                paginationPerPage={request.limit}
                                totalRows={logsData?.body?.total}
                                handlePerRowsChange={handlePerRowsChange}
                                handlePageChange={handlePageChange}
                                pagination
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
